import { RadioButton } from './radio.component';

export * from './radio.component';
export default RadioButton;

RadioButton.define('der-ui-radio-button');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-radio-button': RadioButton;
    }
}
